import React from "react";

const About = () => {
  return (
    <div>
      <h3>Why you should choose us</h3>
      <p>
        We are working as a community with our students by giving them world
        class courses in a very low amount since 2006
      </p>
      <p>
        It is important to remember that the traditional academic subjects that
        are referred to today, such as chemistry, music and geography, are
        simply artificial boxes used to understand the growing awareness of our
        lives and universe. People have always tried to make sense of our world
        by trying to organise our knowledge into compartments. Over time, these
        compartments have changed and multiplied, and as a result, we have ended
        up with distinct subjects such as history, mathematics and business.
      </p>
      <p>
        When you go to study abroad, you come to realize this fact some day or
        the other that no one but you is going to take care of yourself in the
        distant land. You start valuing everything you have – your time, your
        money, the efforts of your parents and their support in helping you get
        a degree. This instils a sense of maturity in you and you tend to
        develop the seriousness you need to stay focused and build a career for
        yourself in life.
      </p>
    </div>
  );
};

export default About;
